export default {
  CHECKOUT_TO_SPEND_REWARD_POINT: '[QUOTE] CHECKOUT_TO_SPEND_REWARD_POINT',
}



// WEBPACK FOOTER //
// ./src/extension/reward-points/view/constant/actions.js